export const SHIKI_THEMES = {
  light: 'github-light-default',
  dark: 'github-dark-default',
} as const

export const SHIKI_THEME_IMPORTS = [
  import('@shikijs/themes/github-light-default'),
  import('@shikijs/themes/github-dark-default'),
]
